<script>
  import { onMount } from "svelte";
  import Icon from "@iconify/svelte";
  import Layout from "../components/Layout.svelte";
  import Skeleton from "../components/Skeleton.svelte";
  import { t } from "../lib/i18n.svelte.js";
  import { api } from "../lib/api.svelte.js";

  let data = $state(null);
  let loading = $state(true);
  let error = $state(null);

  async function load() {
    loading = true;
    error = null;
    try {
      data = await api.get("/setup");
    } catch (e) {
      error = e.message;
    }
    loading = false;
  }

  onMount(load);

  let sections = $derived.by(() => {
    if (!data?.env) return [];
    const map = {};
    for (const e of data.env) {
      const s = e.section || "other";
      if (!map[s]) map[s] = [];
      map[s].push(e);
    }
    return Object.entries(map);
  });
</script>

<Layout>
  <div class="ui-card p-5 sm:p-6">
    <!-- Header -->
    <div class="flex items-start gap-3 mb-6">
      <span class="ui-header-icon">
        <Icon icon="mdi:cog" class="w-[18px] h-[18px]" />
      </span>
      <div class="flex-1">
        <h1 class="text-lg font-normal tracking-wide text-zinc-100">{t("nav.settings")}</h1>
        <p class="mt-0.5 text-sm text-zinc-400">{t("settings.subtitle")}</p>
      </div>
      <button class="ui-btn" onclick={load}>
        <Icon icon="mdi:refresh" class="w-4 h-4" />
        {t("common.refresh")}
      </button>
    </div>

    {#if loading}
      <Skeleton lines={8} />
    {:else if error}
      <div class="p-4 rounded border border-rose-500/30 bg-rose-500/10 text-rose-300 text-sm">{error}</div>
    {:else}
      <!-- Meta info -->
      {#if data.meta}
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
          <div class="p-3 rounded bg-white/[0.03] border border-white/[0.06]">
            <p class="text-xs text-zinc-500 mb-1">{t("settings.hostname")}</p>
            <p class="text-sm font-mono text-zinc-200">{data.meta.hostname}</p>
          </div>
          <div class="p-3 rounded bg-white/[0.03] border border-white/[0.06]">
            <p class="text-xs text-zinc-500 mb-1">{t("settings.server_time")}</p>
            <p class="text-sm font-mono text-zinc-200">{new Date(data.meta.now_utc).toLocaleTimeString()}</p>
          </div>
        </div>
      {/if}

      {#each sections as [section, vars], i}
        {#if i > 0 || data.meta}
          <div class="border-t border-white/10 pt-5 mt-5"></div>
        {/if}
        <h2 class="text-sm font-normal uppercase tracking-wider mb-3" style="color: var(--snap-accent-hex)">{section}</h2>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {#each vars as v}
            <div class="p-3 rounded bg-white/[0.03] border border-white/[0.06]">
              <p class="text-xs text-zinc-500 mb-1">{v.name}</p>
              <p class="text-sm font-mono text-zinc-200 break-all">{v.value || '\u2014'}</p>
            </div>
          {/each}
        </div>
      {/each}
    {/if}
  </div>
</Layout>
